import V1 from '@/system-modules/sync/v1/SysSyncV1'
import { ISysSyncModule } from '@/contracts/system-modules/sync/ISysSyncModule'
import { Provider } from '@/contracts/core/provider/entity/Provider'
import SystemModuleConfig from '@/contracts/system/configs/SystemModuleConfig'

export class SysSyncProvider extends Provider<ISysSyncModule> {
  realizations: Record<string, ISysSyncModule> = {
    v1: V1(),
  }
}

const instance: { module: ISysSyncModule | null } = { module: null }

export function SysSyncProviderModule(): ISysSyncModule {
  const version = SystemModuleConfig.getSyncVersion()

  if (!instance.module) {
    instance.module = new SysSyncProvider().module(version)
  }

  return instance.module
}
